'use client';

import IndexedDB from '@/helpers/singletons/indexedDB';
import React, { createContext, useContext, useEffect, useState } from 'react';

const IndexedDBContext = createContext<IndexedDB | null>(null);

export const IndexedDBProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [dbInstance, setDbInstance] = useState<IndexedDB | null>(null);

  useEffect(() => {
    const initDB = async () => {
      const instance = await IndexedDB.getInstance();
      setDbInstance(instance);
    };
    initDB();

    return () => {
      dbInstance?.close();
    };
  }, []);

  return (
    <IndexedDBContext.Provider value={dbInstance}>
      {children}
    </IndexedDBContext.Provider>
  );
};

export const useIndexedDB = () => {
  return useContext(IndexedDBContext);
};
